module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "field-survey"
  }, [(_vm.surveyMethodDialog) ? _c('v-dialog', {
    attrs: {
      "content-class": "survey-method-dialog"
    },
    model: {
      value: (_vm.surveyMethodDialog),
      callback: function($$v) {
        _vm.surveyMethodDialog = $$v
      },
      expression: "surveyMethodDialog"
    }
  }, [_c('v-card', [_c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "px-0 mt-0 py-0",
    attrs: {
      "cols": "8",
      "offset": "2"
    }
  }, [_c('v-card-title', {
    staticClass: "survey-method-dialog-title text-break justify-center mb-0 text-center px-0",
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("\n            Método de relevamiento en campo\n          ")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-2 text-end",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.surveyMethodDialog = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#00202F"
    }
  }, [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("\n          El relevamiento se realiza por medio de una aplicación (desarrollada por PONCE), donde el técnico recorre el equipo\n          relevando la marca, modelo y estado de cada uno de los componentes.\n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n          Cada bajante queda entonces numerada y se establece así un registro dónde se detalla si el equipo cuenta con regulador de\n          presión, el modelo del aspersor, el tamaño de boquilla, el modelo de difusor y varios parámetros adicionales.\n        ")]), _vm._v(" "), _c('v-img', {
    staticClass: "mt-5",
    attrs: {
      "src": require('../../assets/audits/surveyMethod.png'),
      "max-width": "315px"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.commentsDialog) ? _c('v-dialog', {
    attrs: {
      "content-class": "comments-dialog"
    },
    model: {
      value: (_vm.commentsDialog),
      callback: function($$v) {
        _vm.commentsDialog = $$v
      },
      expression: "commentsDialog"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "py-3"
  }, [_vm._v("\n          " + _vm._s(_vm.comments) + "\n      ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', [_c('p', {
    staticClass: "field-survey-title mb-0"
  }, [_vm._v("Detalle de relevamiento")]), _vm._v(" "), _c('a', {
    staticClass: "field-survey-subtitle mb-0",
    on: {
      "click": function($event) {
        _vm.surveyMethodDialog = true
      }
    }
  }, [_vm._v("Método de relevamiento")])]), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "align-content": "center"
    },
    attrs: {
      "align": "end"
    }
  }, [_c('v-icon', {
    staticClass: "d-inline icon-center",
    attrs: {
      "color": "#00202F",
      "size": "1rem"
    }
  }, [_vm._v("date_range")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 d-inline"
  }, [_vm._v(_vm._s(_vm.parseDate(_vm.auditData.workDate)))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-container', {
    staticClass: "Content d-flex pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "Options overflow-hidden pr-1 mr-3"
  }, [_c('v-radio-group', {
    staticClass: "px-4 pt-0",
    attrs: {
      "mandatory": ""
    },
    model: {
      value: (_vm.selectedOption),
      callback: function($$v) {
        _vm.selectedOption = $$v
      },
      expression: "selectedOption"
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('v-radio', {
      key: option,
      style: ({
        'font-weight': _vm.selectedOption === option ? '600' : '400'
      }),
      attrs: {
        "label": option,
        "value": option,
        "color": "#0098E1"
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "Graphic fill-height align-center justify-left"
  }, [(_vm.selectedOption === 'Recomendaciones') ? [(_vm.checkObservationsDocumentEmpty()) ? _c('div', {
    staticStyle: {
      "height": "100%",
      "place-content": "center"
    }
  }, [_c('p', {
    staticClass: "text-center mb-0"
  }, [_vm._v("No hay recomendaciones")])]) : _c('KeystoneDocumentRenderer', {
    attrs: {
      "document": _vm.auditData.observations.document
    }
  })] : (_vm.selectedOption === 'Bajantes a revisar') ? [_c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "px-0",
    attrs: {
      "offset": "1",
      "align": "left"
    }
  }, [_c('p', {
    staticClass: "survey-text-label mb-0"
  }, [_c('strong', [_vm._v(_vm._s(_vm.outletsConfigurationAnalysis.total - _vm.outletsConfigurationAnalysis.correct))]), _vm._v(" de " + _vm._s(_vm.outletsConfigurationAnalysis.total) + " bajantes a revisar")])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "px-2 pb-0 text-end",
    attrs: {
      "cols": "1"
    }
  }, [(_vm.outletsConfigurationAnalysis.outletsWithoutRegulator.length > 0) ? _c('v-icon', {
    staticClass: "icon-center",
    attrs: {
      "size": "1rem",
      "color": "#F93A2F"
    }
  }, [_vm._v("report")]) : _c('v-icon', {
    staticClass: "icon-center",
    attrs: {
      "size": "1rem",
      "color": "#52B847"
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-0 pb-0"
  }, [_c('v-row', [_c('p', {
    staticClass: "survey-text-body-label text-left mb-0"
  }, [_vm._v("Cantidad de aspersores sin regulador:")]), _vm._v(" "), _c('p', {
    staticClass: "survey-text-body text-left mb-0 ml-1"
  }, [_vm._v(_vm._s(_vm.outletsConfigurationAnalysis.outletsWithoutRegulator.length))])]), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0"
  }, _vm._l((_vm.outletsConfigurationAnalysis.outletsWithoutRegulator), function(outlet, outletIndex) {
    return _c('v-chip', {
      key: outletIndex,
      staticClass: "mr-2 my-1",
      attrs: {
        "small": "",
        "label": ""
      }
    }, [_vm._v("Bajante " + _vm._s(outlet.outletNumber) + " (Tramo " + _vm._s(outlet.spanNumber) + ")")])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "px-2 pb-0 text-end",
    attrs: {
      "cols": "1"
    }
  }, [(Object.keys(_vm.outletsReportData.regulatorModels).length > 1) ? _c('v-icon', {
    staticClass: "icon-center",
    attrs: {
      "size": "1rem",
      "color": "#F8C300"
    }
  }, [_vm._v("mdi-alert")]) : _c('v-icon', {
    staticClass: "icon-center",
    attrs: {
      "size": "1rem",
      "color": "#52B847"
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-0 pb-0"
  }, [_c('v-row', [_c('p', {
    staticClass: "survey-text-body-label text-left mb-0"
  }, [_vm._v("Modelos de reguladores:")]), _vm._v(" "), _c('p', {
    staticClass: "survey-text-body text-left mb-0 ml-1"
  }, [_vm._v(_vm._s(Object.keys(_vm.outletsReportData.regulatorModels).length))])]), _vm._v(" "), _c('v-row', _vm._l((Object.keys(_vm.outletsReportData.regulatorModels)), function(regulatorModel) {
    return _c('v-chip', {
      key: regulatorModel,
      staticClass: "mr-2 my-1",
      attrs: {
        "small": "",
        "label": ""
      }
    }, [_vm._v(_vm._s(regulatorModel) + " (" + _vm._s(_vm.outletsReportData.regulatorModels[regulatorModel]) + " " + _vm._s(_vm.outletsReportData.regulatorModels[regulatorModel] === 1 ? 'bajante' : 'bajantes') + ")")])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "px-2 pb-0 text-end",
    attrs: {
      "cols": "1"
    }
  }, [(Object.keys(_vm.outletsReportData.sprinklerModels).length > 1) ? _c('v-icon', {
    staticClass: "icon-center",
    attrs: {
      "size": "1rem",
      "color": "#F8C300"
    }
  }, [_vm._v("mdi-alert")]) : _c('v-icon', {
    staticClass: "icon-center",
    attrs: {
      "size": "1rem",
      "color": "#52B847"
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-0 pb-0"
  }, [_c('v-row', [_c('p', {
    staticClass: "survey-text-body-label text-left mb-0"
  }, [_vm._v("Cantidad de modelos de aspersor:")]), _vm._v(" "), _c('p', {
    staticClass: "survey-text-body text-left mb-0 ml-1"
  }, [_vm._v(_vm._s(Object.keys(_vm.outletsReportData.sprinklerModels).length))])]), _vm._v(" "), _c('v-row', _vm._l((Object.keys(_vm.outletsReportData.sprinklerModels)), function(sprinklerModel) {
    return _c('v-chip', {
      key: sprinklerModel,
      staticClass: "mr-2 my-1",
      attrs: {
        "small": "",
        "label": ""
      }
    }, [_vm._v(_vm._s(sprinklerModel) + " (" + _vm._s(_vm.outletsReportData.sprinklerModels[sprinklerModel]) + " " + _vm._s(_vm.outletsReportData.sprinklerModels[sprinklerModel] === 1 ? 'bajante' : 'bajantes') + ")")])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "px-2 pb-0 text-end",
    attrs: {
      "cols": "1"
    }
  }, [(_vm.outletsConfigurationAnalysis.sprinklersWithoutNozzle.length > 0) ? _c('v-icon', {
    staticClass: "icon-center",
    attrs: {
      "size": "1rem",
      "color": "#F93A2F"
    }
  }, [_vm._v("report")]) : _c('v-icon', {
    staticClass: "icon-center",
    attrs: {
      "size": "1rem",
      "color": "#52B847"
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-0 pb-0"
  }, [_c('v-row', [_c('p', {
    staticClass: "survey-text-body-label text-left mb-0"
  }, [_vm._v("Cantidad de aspersores sin boquilla:")]), _vm._v(" "), _c('p', {
    staticClass: "survey-text-body text-left mb-0 ml-1"
  }, [_vm._v(_vm._s(_vm.outletsConfigurationAnalysis.sprinklersWithoutNozzle.length))])]), _vm._v(" "), _c('v-row', _vm._l((_vm.outletsConfigurationAnalysis.sprinklersWithoutNozzle), function(sprinkler, sprinklerIndex) {
    return _c('v-chip', {
      key: sprinklerIndex,
      staticClass: "mr-2 my-1",
      attrs: {
        "small": "",
        "label": ""
      }
    }, [_vm._v("Bajante " + _vm._s(sprinkler.outletNumber) + " (Tramo " + _vm._s(sprinkler.spanNumber) + ")")])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "px-2 pb-0 text-end",
    attrs: {
      "cols": "1"
    }
  }, [(_vm.outletsConfigurationAnalysis.sprinklersWithoutPad.length > 0) ? _c('v-icon', {
    staticClass: "icon-center",
    attrs: {
      "size": "1rem",
      "color": "#F93A2F"
    }
  }, [_vm._v("report")]) : _c('v-icon', {
    staticClass: "icon-center",
    attrs: {
      "size": "1rem",
      "color": "#52B847"
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-0 pb-0"
  }, [_c('v-row', [_c('p', {
    staticClass: "survey-text-body-label text-left mb-0"
  }, [_vm._v("Cantidad de aspersores sin deflector:")]), _vm._v(" "), _c('p', {
    staticClass: "survey-text-body text-left mb-0 ml-1"
  }, [_vm._v(_vm._s(_vm.outletsConfigurationAnalysis.sprinklersWithoutPad.length))])]), _vm._v(" "), _c('v-row', _vm._l((_vm.outletsConfigurationAnalysis.sprinklersWithoutPad), function(sprinkler, sprinklerIndex) {
    return _c('v-chip', {
      key: sprinklerIndex,
      staticClass: "mr-2 my-1",
      attrs: {
        "small": "",
        "label": ""
      }
    }, [_vm._v("Bajante " + _vm._s(sprinkler.outletNumber) + " (Tramo " + _vm._s(sprinkler.spanNumber) + ")")])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "px-2 pb-0 text-end",
    attrs: {
      "cols": "1"
    }
  }, [(Object.keys(_vm.outletsReportData.padModels).length > 1) ? _c('v-icon', {
    staticClass: "icon-center",
    attrs: {
      "size": "1rem",
      "color": "#F8C300"
    }
  }, [_vm._v("mdi-alert")]) : _c('v-icon', {
    staticClass: "icon-center",
    attrs: {
      "size": "1rem",
      "color": "#52B847"
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-0 pb-0"
  }, [_c('v-row', [_c('p', {
    staticClass: "survey-text-body-label text-left mb-0"
  }, [_vm._v("Modelos de deflectores:")]), _vm._v(" "), _c('p', {
    staticClass: "survey-text-body text-left mb-0 ml-1"
  }, [_vm._v(_vm._s(Object.keys(_vm.outletsReportData.padModels).length))])]), _vm._v(" "), _c('v-row', _vm._l((Object.keys(_vm.outletsReportData.padModels)), function(padModel) {
    return _c('v-chip', {
      key: padModel,
      staticClass: "mr-2 my-1",
      attrs: {
        "small": "",
        "label": ""
      }
    }, [_vm._v(_vm._s(padModel) + " (" + _vm._s(_vm.outletsReportData.padModels[padModel]) + " " + _vm._s(_vm.outletsReportData.padModels[padModel] === 1 ? 'bajante' : 'bajantes') + ")")])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "px-2 pb-0 text-end",
    attrs: {
      "cols": "1"
    }
  }, [(_vm.outletsReportData.outletsWithoutWeight.length > 0) ? _c('v-icon', {
    staticClass: "icon-center",
    attrs: {
      "size": "1rem",
      "color": "#F8C300"
    }
  }, [_vm._v("mdi-alert")]) : _c('v-icon', {
    staticClass: "icon-center",
    attrs: {
      "size": "1rem",
      "color": "#52B847"
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-0 pb-0"
  }, [_c('v-row', [_c('p', {
    staticClass: "survey-text-body-label text-left mb-0"
  }, [_vm._v("Porcentaje de bajantes sin peso:")]), _vm._v(" "), _c('p', {
    staticClass: "survey-text-body text-left mb-0 ml-1"
  }, [_vm._v(_vm._s(_vm.outletsReportData.allOutletsCount > 0 ? _vm.formatNumber((_vm.outletsReportData.outletsWithoutWeight.length * 100) / _vm.outletsReportData.allOutletsCount) : 0) + "%")])]), _vm._v(" "), _c('v-row', _vm._l((_vm.outletsReportData.outletsWithoutWeight), function(outlet, outletIndex) {
    return _c('v-chip', {
      key: outletIndex,
      staticClass: "mr-2 my-1",
      attrs: {
        "small": "",
        "label": ""
      }
    }, [_vm._v("Bajante " + _vm._s(outlet.outletNumber) + " (Tramo " + _vm._s(outlet.spanNumber) + ")")])
  }), 1)], 1)], 1)] : (_vm.selectedOption === 'Equipo') ? [_c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', [_c('v-row', [_c('v-icon', {
    attrs: {
      "size": "1.38rem",
      "color": "#00202F"
    }
  }, [_vm._v("mdi-sprinkler-fire")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-2",
    staticStyle: {
      "font-size": "1.13rem",
      "font-weight": "600"
    }
  }, [_vm._v("Equipo")])], 1), _vm._v(" "), _c('v-row', [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Tipo de equipo:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v("Pivot")])]), _vm._v(" "), _c('v-row', [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Marca:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.auditData.brand || '-'))])]), _vm._v(" "), _c('v-row', [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Modelo:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.auditData.model || '-'))])]), _vm._v(" "), _c('v-row', [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Alimentación:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.auditData.powerSource ? _vm.auditData.powerSource.name : '-'))])]), _vm._v(" "), _c('v-row', [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Móvil:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.auditData.device.isMobile ? 'Si' : 'No'))])]), _vm._v(" "), _c('v-row', [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Cañón:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.auditData.endSystems.some(function (system) { return system && system.outletType && system.outletType.id === _vm.CANNON_OUTLET_TYPE_ID; }) ? 'Si' : 'No'))])]), _vm._v(" "), _c('v-row', [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Tablero:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.auditData.panelBrand || _vm.auditData.panelModel ? ("" + (_vm.auditData.panelBrand ? ((_vm.auditData.panelBrand) + " ") : '') + (_vm.auditData.panelModel)) : '-'))])])], 1), _vm._v(" "), _c('v-col', [_c('v-row', [_c('v-icon', {
    attrs: {
      "size": "1.38rem",
      "color": "#00202F"
    }
  }, [_vm._v("mdi-pipe-valve")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-2",
    staticStyle: {
      "font-size": "1.13rem",
      "font-weight": "600"
    }
  }, [_vm._v("Accesorios")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-left my-3"
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400",
      "display": "inline"
    }
  }, [_vm._v("Reguladores:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300",
      "display": "inline"
    }
  }, [_vm._v(_vm._s(Object.keys(_vm.outletsReportData.regulatorModels).length > 0 ? Object.keys(_vm.outletsReportData.regulatorModels).join(', ') : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "text-left my-3"
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400",
      "display": "inline"
    }
  }, [_vm._v("Aspersores:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300",
      "display": "inline"
    }
  }, [_vm._v(_vm._s(Object.keys(_vm.outletsReportData.sprinklerModels).length > 0 ? Object.keys(_vm.outletsReportData.sprinklerModels).join(', ') : '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "text-left my-3"
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400",
      "display": "inline"
    }
  }, [_vm._v("Tipos de cubierta:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300",
      "display": "inline"
    }
  }, [_vm._v(_vm._s(_vm.outletsReportData.tyreSizes.length > 0 ? _vm.outletsReportData.tyreSizes.join(', ') : '-'))])])], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', [_c('v-row', [_c('v-icon', {
    attrs: {
      "size": "1.38rem",
      "color": "#00202F"
    }
  }, [_vm._v("mdi-gauge")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-2",
    staticStyle: {
      "font-size": "1.13rem",
      "font-weight": "600"
    }
  }, [_vm._v("Caudal")])], 1), _vm._v(" "), _c('v-row', [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Caudal total teórico:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.auditData.calculatedData ? ((_vm.formatNumber(_vm.auditData.calculatedData.totalFlow)) + " m3/h") : '-'))])]), _vm._v(" "), _c('v-row', [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Capacidad de Riego Teórica:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.auditData.calculatedData ? ((_vm.formatNumber(_vm.auditData.calculatedData.irrigationCapacity)) + " mm") : '-'))])]), _vm._v(" "), _c('v-row', [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Horas de riego con márgen:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.auditData.calculatedData ? ((_vm.formatNumber(_vm.auditData.calculatedData.irrigationHoursWithMargin)) + " hs") : '-'))])])], 1), _vm._v(" "), _c('v-col', [_c('v-row', [_c('v-icon', {
    attrs: {
      "size": "1.38rem",
      "color": "#00202F"
    }
  }, [_vm._v("mdi-arrow-expand-horizontal")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-2",
    staticStyle: {
      "font-size": "1.13rem",
      "font-weight": "600"
    }
  }, [_vm._v("Dimensiones")])], 1), _vm._v(" "), _c('v-row', [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Longitud total de riego teórica:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.outletsReportData.theoreticalIrrigationTotalLength)) + " m")])]), _vm._v(" "), _c('v-row', [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Superficie de riego teórica:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.auditData.calculatedData ? ((_vm.formatNumber(_vm.auditData.calculatedData.totalIrrigationArea)) + " ha") : '-') + " ")])])], 1)], 1), _vm._v(" "), (_vm.outletsReportData.endsOfSystemData && _vm.outletsReportData.endsOfSystemData.length > 0) ? _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', [_c('v-row', [_c('v-icon', {
    attrs: {
      "size": "1.38rem",
      "color": "#00202F"
    }
  }, [_vm._v("mdi-weather-windy")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-2",
    staticStyle: {
      "font-size": "1.13rem",
      "font-weight": "600"
    }
  }, [_vm._v("Final de sistema")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "2"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Modelo")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "2"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Aspersor")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "1"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Presión")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "2"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Caudal (m3/h)")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "1"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Radio")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "4"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Comentarios")])])], 1), _vm._v(" "), _vm._l((_vm.outletsReportData.endsOfSystemData), function(endOfSystem, endOfSystemIndex) {
    return _c('v-row', {
      key: endOfSystemIndex,
      staticClass: "mt-1"
    }, [_c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "2"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(endOfSystem.sprinklerType && endOfSystem.sprinklerType.model ? endOfSystem.sprinklerType.model : '-'))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "2"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(endOfSystem.sprinklerType && endOfSystem.sprinklerType.brand ? endOfSystem.sprinklerType.brand : '-') + "-" + _vm._s(endOfSystem.sprinklerType && endOfSystem.sprinklerType.model ? endOfSystem.sprinklerType.model : '-') + _vm._s(endOfSystem.nozzle && endOfSystem.nozzle.size ? ("-" + (endOfSystem.nozzle.size)) : ''))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "1"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(endOfSystem.endPressure ? _vm.formatNumber(endOfSystem.endPressure) : '-') + " psi")])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "2"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(_vm.formatNumber(endOfSystem.flow, 2)))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "1"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(_vm.formatNumber(endOfSystem.radius)) + " m")])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "4"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(endOfSystem.observations ? endOfSystem.observations : '-'))])])], 1)
  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.auditData.spans && _vm.auditData.spans.length > 0) ? _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', [_c('v-row', [_c('v-icon', {
    attrs: {
      "size": "1.38rem",
      "color": "#00202F"
    }
  }, [_vm._v("mdi-transit-connection-horizontal")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-2",
    staticStyle: {
      "font-size": "1.13rem",
      "font-weight": "600"
    }
  }, [_vm._v("Tramos")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "1"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Tramo")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "1"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Caños")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "1"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Caudal (m3/h)")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "2"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Largo tramo / acumulado (m)")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "2"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Motorreductor")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "1"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Cubiertas")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "2"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Bajantes instaladas / totales")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0",
    attrs: {
      "cols": "2"
    }
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Comentarios")])])], 1), _vm._v(" "), _vm._l((_vm.sortedSpans), function(span, spanIndex) {
    return _c('v-row', {
      key: spanIndex,
      staticClass: "mt-1"
    }, [_c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "1"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(span.spanType ? span.spanType.id === _vm.SPAN_TYPE_SPAN_ID ? ("Tramo " + (span.number)) : span.spanType.name : '-'))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "1"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(span.pipeAmount) + " x " + _vm._s(span.pipe ? span.pipe.diameter : '-'))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "1"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(span.calculatedData && span.calculatedData.currentFlow ? _vm.formatNumber(span.calculatedData.currentFlow, 2) : '-'))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "2"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(_vm.formatNumber(span.length)) + " / " + _vm._s(span.calculatedData && span.calculatedData.accLarge ? _vm.formatNumber(span.calculatedData.accLarge) : '-'))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "2"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(span.tower && span.tower.motor && span.tower.motor.rpm ? ![_vm.OTHER_MOTOR_RPM_ID, _vm.NO_VISIBLE_MOTOR_RPM_NAME].includes(span.tower.motor.rpm.id) ? ((span.tower.motor.rpm.name) + " RPM") : span.tower.motor.rpm.id === _vm.OTHER_MOTOR_RPM_ID ? 'Otro' : span.tower.motor.rpm.name : '-'))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "1"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(_vm.getUniqueTyreSizes(span.tower && span.tower.tyres)))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "2"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(span.outlets && span.outlets.filter(function (outlet) { return outlet && outlet.type && outlet.type.id === _vm.OUTLET_TYPE_OUTLET_ID; }).length) + "/" + _vm._s(span.outlets && span.outlets.length))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0",
      attrs: {
        "cols": "2"
      }
    }, [_c('v-icon', {
      staticStyle: {
        "font-size": "1.2rem",
        "font-weight": "400",
        "color": "#00202F"
      },
      on: {
        "click": function($event) {
          return _vm.openCommentsDialog(span.observations)
        }
      }
    }, [_vm._v("mdi-comment-text-outline")])], 1)], 1)
  })], 2)], 1) : _vm._e()] : (_vm.selectedOption === 'Altimetría') ? [_c('v-row', [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Centro de lote:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.auditData.device && _vm.auditData.device.locationLatitude && _vm.auditData.device.locationLongitude ? ((_vm.auditData.device.locationLatitude) + ", " + (_vm.auditData.device.locationLongitude)) : '-'))]), _vm._v(" "), (_vm.auditData.device && _vm.auditData.device.locationLatitude && _vm.auditData.device.locationLongitude) ? _c('v-icon', {
    staticClass: "ml-1 mr-3",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "size": "1.38rem",
      "color": "#0099E1"
    },
    on: {
      "click": function($event) {
        return _vm.goToLocation(_vm.auditData.device.locationLatitude, _vm.auditData.device.locationLongitude)
      }
    }
  }, [_vm._v("mdi-map-marker")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-5",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Altimetría de centro:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.elevationReference ? ((_vm.formatNumber(_vm.elevationReference.centerElevation)) + " m") : '-'))])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-5"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "size": "1.38rem",
      "color": "#F93A2F"
    }
  }, [_vm._v("mdi-arrow-expand-up")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Altimetría máxima:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1 mr-3",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.elevationReference ?
    _vm.formatNumber(_vm.elevationReference.max) : '') + " m")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-5",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Ángulo:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1 mr-3",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.elevationReference ? _vm.formatNumber(_vm.elevationReference.maxAngle) : '') + "°")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-5",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Cota máxima:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.elevationReference ? _vm.formatNumber(_vm.elevationReference.max - _vm.elevationReference.centerElevation) : '') + " m")])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-5"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "size": "1.38rem",
      "color": "#00D166"
    }
  }, [_vm._v("mdi-arrow-collapse-down")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Altimetría mínima:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1 mr-3",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.elevationReference ?
    _vm.formatNumber(_vm.elevationReference.min) : '') + " m")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-5",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Ángulo:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1 mr-3",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.elevationReference ? _vm.formatNumber(_vm.elevationReference.minAngle) : '') + "°")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-5",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Cota mínima:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 ml-1",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.elevationReference ? _vm.formatNumber(_vm.elevationReference.centerElevation - _vm.elevationReference.min) : '') + " m")])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-5"
  }, [_c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "GraphicImage MapGraphicImage"
  }, [_c('div', {
    staticClass: "GraphicImageContent MapGraphicImageContent"
  }, [_c('CardSatelliteImage', {
    attrs: {
      "hasHeatmap": true,
      "position": {
        latitude: _vm.auditData.device && _vm.auditData.device.locationLatitude && _vm.auditData.device.locationLongitude ? parseFloat(_vm.auditData.device.locationLatitude) : 0,
        longitude: _vm.auditData.device && _vm.auditData.device.locationLatitude && _vm.auditData.device.locationLongitude ? parseFloat(_vm.auditData.device.locationLongitude) : 0
      },
      "zoom": _vm.getPivotZoomHandler(_vm.outletsReportData.theoreticalIrrigationTotalLength),
      "equipLength": _vm.outletsReportData.theoreticalIrrigationTotalLength,
      "heatmapData": _vm.heatmapData,
      "elevationReference": _vm.elevationReference,
      "addTransparentLayer": false,
      "isAuditPivot": true,
      "mapInstanceId": _vm.auditData.device.id
    },
    on: {
      "update:heatmapData": function($event) {
        _vm.heatmapData = $event
      },
      "update:heatmap-data": function($event) {
        _vm.heatmapData = $event
      },
      "update:elevationReference": function($event) {
        _vm.elevationReference = $event
      },
      "update:elevation-reference": function($event) {
        _vm.elevationReference = $event
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "AngleLabel Top"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("CardCircularGraphics.north")))]), _c('br'), _c('span', [_vm._v("0°")])]), _vm._v(" "), _c('p', {
    staticClass: "AngleLabel Right"
  }, [_vm._v("90°")]), _vm._v(" "), _c('p', {
    staticClass: "AngleLabel Bottom"
  }, [_vm._v("180°")]), _vm._v(" "), _c('p', {
    staticClass: "AngleLabel Left"
  }, [_vm._v("270°")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ExtraInfo d-flex pl-3"
  }, [(_vm.elevationReference) ? _c('div', {
    staticClass: "AltimetryReference d-flex mb-0"
  }, [_c('div', {
    staticClass: "ColorReference ml-1"
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "ElevationValues",
    attrs: {
      "column": ""
    }
  }, [_c('p', {
    staticClass: "ma-0 ml-2 subheading text-left"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.elevationReference.max)) + " m")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('p', {
    staticClass: "ma-0 ml-2 subheading text-left"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.elevationReference.min)) + " m")])], 1)], 1) : _vm._e()])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1"
  }, [_c('div', {
    staticClass: "GraphicImage"
  }, [_c('div', {
    staticClass: "GraphicImageContent"
  }, [_c('apexchart', {
    ref: "altimetryLineChart",
    staticClass: "linear-altimetry",
    attrs: {
      "width": "100%",
      "height": "300",
      "type": "line",
      "options": _vm.altimetryLineChart.options,
      "series": _vm.altimetryLineChart.values
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-center mb-0",
    staticStyle: {
      "font-weight": "400",
      "font-size": "14px"
    }
  }, [_vm._v("Distancia al centro (m)")])], 1)])])], 1)] : (_vm.selectedOption === 'Uniformidad') ? [_c('v-row', {
    staticClass: "mt-5"
  }, [_c('div', {
    staticClass: "GraphicImage"
  }, [_c('div', {
    staticClass: "GraphicImageContent"
  }, [_c('apexchart', {
    ref: "uniformityLineChart",
    staticClass: "linear-uniformity",
    attrs: {
      "width": "100%",
      "height": "300",
      "type": "line",
      "options": _vm.uniformityLineChart.options,
      "series": _vm.uniformityLineChart.values
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-center mb-0",
    staticStyle: {
      "font-weight": "400",
      "font-size": "14px"
    }
  }, [_vm._v("Bajante")])], 1)])]), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "px-1 py-0"
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Tramo")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0"
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Largo acumulado (m)")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0"
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Área cubierta (has)")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0"
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Caudal requerido (m3/h)")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0"
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Caudal actual (m3/h)")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0"
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("% Desvío")])]), _vm._v(" "), _c('v-col', {
    staticClass: "px-1 py-0"
  }, [_c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400"
    }
  }, [_vm._v("Diferencia (m3/h)")])])], 1), _vm._v(" "), _vm._l((_vm.sortedSpans), function(span, spanIndex) {
    return _c('v-row', {
      key: spanIndex,
      staticClass: "mt-1"
    }, [_c('v-col', {
      staticClass: "px-1 py-0"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(span.spanType ? span.spanType.id === _vm.SPAN_TYPE_SPAN_ID ? ("Tramo " + (span.number)) : span.spanType.name : '-'))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(span.calculatedData && span.calculatedData.accLarge ? _vm.formatNumber(span.calculatedData.accLarge, 2) : '-'))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(span.calculatedData && span.calculatedData.sectorArea ? _vm.formatNumber(span.calculatedData.sectorArea, 2) : '-'))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(span.calculatedData && span.calculatedData.requiredFlow ? _vm.formatNumber(span.calculatedData.requiredFlow, 2) : '-'))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(span.calculatedData && span.calculatedData.currentFlow ? _vm.formatNumber(span.calculatedData.currentFlow, 2) : '-'))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(span.calculatedData && span.calculatedData.deviation ? ((_vm.formatNumber(span.calculatedData.deviation * 100, 2)) + "%") : '-'))])]), _vm._v(" "), _c('v-col', {
      staticClass: "px-1 py-0"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(span.calculatedData && span.calculatedData.difference ? _vm.formatNumber(span.calculatedData.difference, 2) : '-'))])])], 1)
  })] : (_vm.selectedOption === 'Bajantes') ? [_c('v-container', [_vm._l((_vm.sortedSpans), function(span, index) {
    return [_c('v-row', {
      attrs: {
        "align": "baseline"
      }
    }, [_c('p', {
      staticClass: "body-text pointer mb-0",
      on: {
        "click": function($event) {
          return _vm.toggleOutletsSpanExpanded(index)
        }
      }
    }, [_vm._v("Tramo " + _vm._s(span.number))]), _vm._v(" "), _c('v-btn', {
      staticClass: "my-0 ml-2",
      attrs: {
        "text": "",
        "fab": "",
        "x-small": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleOutletsSpanExpanded(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "rgba(0, 32, 47, 0.5)"
      }
    }, [_vm._v(_vm._s(_vm.outletsSpanExpanded[index] ? 'mdi-chevron-up' : 'mdi-chevron-down'))])], 1)], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.outletsSpanExpanded[index]),
        expression: "outletsSpanExpanded[index]"
      }],
      staticClass: "table-scroll-container"
    }, [_c('div', {
      staticClass: "table-content"
    }, [_c('div', {
      staticClass: "table-row table-header"
    }, [_c('div', {
      staticClass: "table-cell"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("Salida")])]), _vm._v(" "), _c('div', {
      staticClass: "table-cell"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("Tipo")])]), _vm._v(" "), _c('div', {
      staticClass: "table-cell"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("Bajante")])]), _vm._v(" "), _c('div', {
      staticClass: "table-cell"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("Regulador")])]), _vm._v(" "), _c('div', {
      staticClass: "table-cell"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("Aspersor")])]), _vm._v(" "), _c('div', {
      staticClass: "table-cell"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("Boquilla")])]), _vm._v(" "), _c('div', {
      staticClass: "table-cell"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("Caudal de boquilla / acumulado (m3/h)")])]), _vm._v(" "), _c('div', {
      staticClass: "table-cell"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("Deflector")])]), _vm._v(" "), _c('div', {
      staticClass: "table-cell"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("Peso")])]), _vm._v(" "), _c('div', {
      staticClass: "table-cell"
    }, [_c('p', {
      staticClass: "mb-0",
      staticStyle: {
        "font-size": "1rem",
        "font-weight": "400"
      }
    }, [_vm._v("Comentarios")])])]), _vm._v(" "), _vm._l((span.outlets), function(outlet, outletIndex) {
      return _c('div', {
        key: outletIndex,
        staticClass: "table-row table-data"
      }, [_c('div', {
        staticClass: "table-cell"
      }, [_c('p', {
        staticClass: "mb-0",
        staticStyle: {
          "font-size": "1rem",
          "font-weight": "300"
        }
      }, [_vm._v(_vm._s(outlet.number))])]), _vm._v(" "), _c('div', {
        staticClass: "table-cell"
      }, [_c('p', {
        staticClass: "mb-0",
        staticStyle: {
          "font-size": "1rem",
          "font-weight": "300"
        }
      }, [_vm._v(_vm._s(outlet.type ? outlet.type.name : '-'))])]), _vm._v(" "), _c('div', {
        staticClass: "table-cell"
      }, [_c('p', {
        staticClass: "mb-0",
        staticStyle: {
          "font-size": "1rem",
          "font-weight": "300"
        }
      }, [_vm._v(_vm._s(!outlet.type || outlet.type.id !== _vm.OUTLET_TYPE_OUTLET_ID ? '-' : outlet.isFlex ? 'Flexible' : 'Rígido'))])]), _vm._v(" "), _c('div', {
        staticClass: "table-cell"
      }, [_c('p', {
        staticClass: "mb-0",
        staticStyle: {
          "font-size": "1rem",
          "font-weight": "300"
        }
      }, [_vm._v(_vm._s(outlet.regulator && outlet.regulator.regulatorType ? ((outlet.regulator.regulatorType.brand) + " " + (outlet.regulator.regulatorType.model)) : '-') + " " + _vm._s(outlet.regulator && outlet.regulator.pressure ? outlet.regulator.pressure.name : ''))])]), _vm._v(" "), _c('div', {
        staticClass: "table-cell"
      }, [_c('p', {
        staticClass: "mb-0",
        staticStyle: {
          "font-size": "1rem",
          "font-weight": "300"
        }
      }, [_vm._v(_vm._s(outlet.sprinkler && outlet.sprinkler.sprinklerType ? outlet.sprinkler.sprinklerType.id === _vm.SPRINKLER_TYPES_WITHOUT_SPRINKLER_ID ? 'No tiene' : ((outlet.sprinkler.sprinklerType.brand) + " " + (outlet.sprinkler.sprinklerType.model)) : '-'))])]), _vm._v(" "), _c('div', {
        staticClass: "table-cell"
      }, [_c('p', {
        staticClass: "mb-0",
        staticStyle: {
          "font-size": "1rem",
          "font-weight": "300"
        }
      }, [_vm._v(_vm._s(outlet.sprinkler && outlet.sprinkler.nozzle ? ((outlet.sprinkler.nozzle.size) + " " + (outlet.sprinkler.nozzle.color)) : '-'))])]), _vm._v(" "), _c('div', {
        staticClass: "table-cell"
      }, [_c('p', {
        staticClass: "mb-0",
        staticStyle: {
          "font-size": "1rem",
          "font-weight": "300"
        }
      }, [_vm._v(_vm._s(!outlet.type || outlet.type.id !== _vm.OUTLET_TYPE_OUTLET_ID ? '-' : ((outlet.flow ? _vm.formatNumber(outlet.flow) : '-') + " / " + (outlet.accFlow ? _vm.formatNumber(outlet.accFlow) : '-'))))])]), _vm._v(" "), _c('div', {
        staticClass: "table-cell"
      }, [_c('p', {
        staticClass: "mb-0",
        staticStyle: {
          "font-size": "1rem",
          "font-weight": "300"
        }
      }, [_vm._v(_vm._s(outlet.sprinkler && outlet.sprinkler.pad ? ((outlet.sprinkler.pad.brand) + " " + (outlet.sprinkler.pad.model)) : '-'))])]), _vm._v(" "), _c('div', {
        staticClass: "table-cell"
      }, [_c('p', {
        staticClass: "mb-0",
        staticStyle: {
          "font-size": "1rem",
          "font-weight": "300"
        }
      }, [_vm._v(_vm._s(!outlet.type || outlet.type.id !== _vm.OUTLET_TYPE_OUTLET_ID ? '-' : outlet.weight ? 'Si' : 'No'))])]), _vm._v(" "), _c('div', {
        staticClass: "table-cell"
      }, [_c('v-icon', {
        staticStyle: {
          "font-size": "1.2rem",
          "font-weight": "400",
          "color": "#00202F"
        },
        on: {
          "click": function($event) {
            return _vm.openCommentsDialog(outlet.observations)
          }
        }
      }, [_vm._v("mdi-comment-text-outline")])], 1)])
    })], 2)])]
  })], 2)] : _vm._e()], 2)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-183aed04","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Audits/FieldSurvey.vue
// module id = 1687
// module chunks = 0